import React from "react";
import { MusicNoteIdentity, MusicScale, Octave } from "../../../../wasm/pkg/wasm";
import { soundSingleNote } from "../../../functions/playNotesAudio";
import { toNoteAndOctaveName, toNoteName } from "../../../models/wasm.model";
import "./MusicNote.css";
import { AppContextType } from "../../../AppContext";

interface Props {
  note_id: MusicNoteIdentity;
  octave?: Octave;
  hideOctave?: boolean;
  highlightWrongNotes?: boolean;
  strikethroughWrongNotes?: boolean;
  scale?: MusicScale;
  /** between 0 and 1 */
  weightOpacity?: number;
}
interface State {}

export default class MusicNote extends React.Component<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;

  handleNoteClick = (e: any) => {
    e.preventDefault();
    soundSingleNote(this.props.note_id, this.props.octave || "Three", { ...this.context.chordHistoryOptions.noteRow });
  };

  render() {
    const { note_id, octave, hideOctave, scale, highlightWrongNotes, strikethroughWrongNotes, weightOpacity } = this.props;
    const isInScale = scale?.shape_notes.some((n) => n.note_id === note_id) || false;
    const strikethroughCss = isInScale || !strikethroughWrongNotes ? "" : "strike-wrong-note";
    const headerClasses = `music-note-header ${strikethroughCss}`;
    const style = {
      background: isInScale || !highlightWrongNotes ? `rgba(1, 1, 1, ${weightOpacity})` : `rgba(255, 165, 0, ${weightOpacity})`,
    };
    return (
      <span className="music-note" style={style}>
        <span className={headerClasses} onClick={this.handleNoteClick}>
          {octave && !hideOctave ? toNoteAndOctaveName(note_id, octave, scale) : toNoteName(note_id, scale)}
        </span>
      </span>
    );
  }
}

MusicNote.contextType = AppContextType;
